<button class="hamburger"
        [class.open]="open">
    <div class="menu">
    </div>
</button>
